import { Injectable } from '@angular/core';

import { AnalyticsBase } from '@core/analytics-legacy';

@Injectable()
export class TasksAnalytics extends AnalyticsBase {
  public readonly namespace = 'Tasks';
  public readonly requireViewContext = true;

  public trackAddTask(
    mode: 'single' | 'bulk',
    isDeadline: boolean,
    isMemberAssigned: boolean,
    candidatesCount: number,
  ) {
    this.track('AddTask', { mode, isDeadline, isMemberAssigned, candidatesCount });
  }

  public trackComplete(isDeadline: boolean, isMemberAssigned: boolean) {
    this.track('Complete', { isDeadline, isMemberAssigned });
  }
}
